module.exports = __webpack_public_path__ + "img/08.b543cee1.png";